// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__YMfPx","selectedTag":"Tag_selectedTag__vy2rH","pin":"Tag_pin__59gP8","text":"Tag_text__qd91p"};